import { render } from "./Incomes.vue?vue&type=template&id=8e781008&scoped=true&bindings={}"
import script from "./Incomes.vue?vue&type=script&lang=ts"
export * from "./Incomes.vue?vue&type=script&lang=ts"

import "./Incomes.vue?vue&type=style&index=0&id=8e781008&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8e781008"

export default script